const slider3Pattern = () => {
	
	const sectionWrapper = document.querySelector(".slider-3-pattern");
	if (!sectionWrapper) return;

	const sliders = sectionWrapper.querySelectorAll(
		".wp-block-create-block-slider-3"
	);
	if (!sliders.length) return;

	const selector = document.createElement("div");
	selector.className = "slider-3-slider-selector";

	const total = sliders.length;

	sliders.forEach((slider, index) => {
		slider.style.zIndex = total - index;
		slider.dataset.sliderIndex = index;

		const title = slider.dataset.sliderTitle || `Slider ${index + 1}`;
		const button = document.createElement("button");
		button.className = "slider-3-slider-selector-title";
		button.textContent = title;
		button.setAttribute("data-slider-index", index);

		if (index === 0) {
			button.classList.add("slider-3-slider-selector-title-active");
		}

		selector.appendChild(button);
	});

	const wrapper = sectionWrapper.querySelector(
		".slider-3-pattern__sliders-wrapper"
	);
	if (!wrapper) return;

	sectionWrapper.insertBefore(selector, wrapper);

	const setWrapperHeight = () => {
		let maxHeight = 0;
		sliders.forEach((slider) => {
			const height = slider.offsetHeight;
			if (height > maxHeight) {
				maxHeight = height;
			}
		});
		wrapper.style.height = `${maxHeight}px`;
	};

	let resizeTimeout = null;
	const handleResize = () => {
		clearTimeout(resizeTimeout);
		resizeTimeout = setTimeout(() => {
			setWrapperHeight();
		}, 150);
	};

	setWrapperHeight();
	window.addEventListener("resize", handleResize);

	const showSlider = (targetIndex) => {
		sliders.forEach((slider, index) => {
			slider.style.display = index == targetIndex ? "block" : "none";
		});

		const buttons = selector.querySelectorAll(
			".slider-3-slider-selector-title"
		);
		buttons.forEach((btn, idx) => {
			btn.classList.toggle(
				"slider-3-slider-selector-title-active",
				idx == targetIndex
			);
		});
	};

	showSlider(0);

	selector.addEventListener("click", (e) => {
		if (e.target.matches("[data-slider-index]")) {
			const index = parseInt(e.target.dataset.sliderIndex, 10);
			showSlider(index);
		}
	});
};

export default slider3Pattern;